import React, { useEffect } from "react";
import { FiX } from "react-icons/fi";

export default function SideDrawerModal({
  isOpen,
  onClose,
  title = "Details",
  width = "520px",
  children,
}) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center sm:justify-end">
      {/* Backdrop */}
      <div
       className="fixed inset-0 bg-[#E6E6E6]/[56%]  transition-opacity"
        onClick={onClose}
      />

      {/* Drawer Container */}
      <div
        style={{
          width: undefined,
        }}
        className={`/* Mobile Responsiveness (< 640px) */ /* Desktop Responsiveness (>= 640px)
          
          */ sm:custom-drawer-width relative z-10 flex h-full
          max-h-[90vh] max-h-screen w-[95%] flex-col
          
          overflow-hidden  bg-white  shadow-[-4px_0px_24px_0px_rgba(0,0,0,0.1686)] transition-all duration-300
          ease-in-out sm:h-screen sm:max-h-screen sm:rounded-none 
        `}
      >
        <style>{`
          @media (min-width: 640px) {
            .sm\\:custom-drawer-width {
              width: ${width} !important;
              max-width: 90vw !important;
            }
          }
        `}</style>

        {/* Header Bar */}
        <div className="flex h-16 shrink-0 items-center justify-between border-b border-gray-100 bg-[var(--color-primary-10)] px-6 text-gray-800">
          <h2 className="text-[18px] font-bold leading-[100%] tracking-[0] text-[#1a1a1a]">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="flex items-center justify-center rounded-md bg-[#F9695A] p-1 focus:outline-none"
            aria-label="Close modal"
          >
            <FiX className="text-sm text-white" />
          </button>
        </div>

        {/* Scrollable Content Container */}
        <div className="min-h-0 flex-1 space-y-6 overflow-y-auto p-3">
          {children}
        </div>
      </div>
    </div>
  );
}
